import {
  formatTimestamp,
  secondsToIso8601Duration,
} from "@marketing-sites/utils/transcript";

import type { TranscriptMarkupProps } from "./transcript.types";

/**
 * Pure, always-hidden (`sr-only`) transcript markup. Cue text ships in the
 * initial HTML for crawlers/answer engines and stays in the a11y tree, but is
 * never visually rendered and takes no layout space. Returns null for no cues.
 */
export const TranscriptMarkup = ({
  cues,
  playerId,
  heading = "Transcript",
}: TranscriptMarkupProps) => {
  if (cues.length === 0) return null;

  const headingId = `transcript-heading-${playerId}`;

  return (
    <section aria-labelledby={headingId} className="aeo-transcript sr-only">
      <h2 id={headingId}>{heading}</h2>
      <ol>
        {cues.map((cue, index) => (
          <li key={index}>
            <time dateTime={secondsToIso8601Duration(cue.start)}>
              {formatTimestamp(cue.start)}
            </time>{" "}
            <span>{cue.text}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};
